import { ApplicationsHoldDepoistPrTimeType } from '@inosio/payments-sdk';

export interface PmConfigType {
  ApplicationsProductEnabled?: boolean;
  ApplicationsMasterFlag?: boolean;
  ApplicationsProductPurchased?: boolean;
  ApplicationsApplicantFee?: number;
  ApplicationsAchAccepted?: boolean;
  ApplicationsCcAccepted?: boolean;
  ApplicationsDbAccepted?: boolean;
  ApplicationsAllowPets?: boolean;
  ApplicationsAppPetFee?: number;
  ApplicationsAllowAdditionalOccupants?: boolean;
  ApplicationsAllowVehicles?: boolean;
  ApplicationsEnableCustomQuestionsSection?: boolean;
  ApplicationsDepositBankAccountUuid?: string;
  ApplicationsEditedLegaleseText?: string;
  ApplicationsPublishedLegaleseText?: string;
  ApplicationsEditedPolicyText?: string;
  ApplicationsPublishedPolicyText?: string;
  ApplicationsEditedPetPolicyText?: string;
  ApplicationsPublishedPetPolicyText?: string;
  ApplicationsHoldDepositIsRefundable?: boolean;
  ApplicationsHoldDepositPrTime?: ApplicationsHoldDepoistPrTimeType;
  ApplicationsHoldDepositBankAccountUuid?: string;
  ApplicationsHoldDepositAmount?: number;
  ApplicationsEmploymentYearsRequired?: number;
  ApplicationsRentalHistoryYearsRequired?: number;
  ApplicationsRequireEmploymentDocsUpload?: boolean;
  ApplicationsRequirePersonalDocsUpload?: boolean;
  ApplicationsRequirePetsDocsUpload?: boolean;
  ShowApplicationDecisionNotificationOption?: boolean;
  AchNotAccpetedAfterDay?: number;
  AchNotAccpetedBeforeDay?: number;
  CcNotAccpetedAfterDay?: number;
  CcNotAccpetedBeforeDay?: number;
  DbNotAccpetedAfterDay?: number;
  DbNotAccpetedBeforeDay?: number;
  AutopayFrequenciesAllowed?: string;
  CancelApOnLeaseEnd?: boolean;
  FapAllowed?: boolean;
  FapNotAfterDate?: number;
  FapNotBeforeDate?: number;
  MarketingEnabled?: boolean;
  MarketingGoLiveDate?: string;
  MaxAllowedPayment?: number; //todo: rename to "MaxAllowedPaymentResidentPortal"
  MaxAllowedPaymentRequestAmount?: number;
  MaxNsfAllowed?: number;
  OwnerDistributionEnabled?: boolean;
  OwnerDistributionPerPmtLimit?: number;
  OwnerDistributionThreeDayLimit?: number;
  OwnerDistributionOneMonthLimit?: number;
  OverPaymentsNotAfter?: number;
  OverPaymentsNotBefore?: number;
  PartialPaymentsNotAfterDay?: number;
  PartialPaymentsNotBeforeDay?: number;
  PaymentsMasterFlag?: boolean;
  PaymentsProductPurchased?: boolean;
  PaymentsProductEnabled?: boolean;
  QuickPayEnabled?: boolean;
  VapAllowed?: boolean;
  VapNotAfterDate?: number;
  VapNotBeforeDate?: number;
  ZeroPaymentsAllowedNotAfter?: number;
  ZeroPaymentsAllowedNotBefore?: number;
  MaintenanceEmergencyPhone?: string;
  MaintenancePolicyText?: string;
  AutopayAllowPayerToSetMaxAmount?: boolean;
  OwnerPortalProductEnabled?: boolean;
  OwnerPortalMasterFlag?: boolean;
  OwnerPortalProductPurchased?: boolean;
  OwnerPaymentDestinationBankAccountUuid?: string;
  WorkOrderDefaultCostLimit?: number;
  [key: string]: any;
}

export enum defaultConfigValues {
  AchNotAcceptedBeforeDay = 1,
  AchNotAcceptedAfterDay = 31,
  CcNotAcceptedBeforeDay = 1,
  CcNotAcceptedAfterDay = 31,
  DbNotAcceptedBeforeDay = 1,
  DbNotAcceptedAfterDay = 31,
  ZeroPaymentsAllowedNotBefore = 1,
  ZeroPaymentsAllowedNotAfter = 31,
  PartialPaymentsNotBeforeDay = 1,
  PartialPaymentsNotAfterDay = 31,
  OverPaymentsNotBefore = 1,
  OverPaymentsNotAfter = 31,
  VapNotBeforeDate = 1,
  VapNotAfterDate = 31,
  FapNotBeforeDate = 1,
  FapNotAfterDate = 31,
}
